@import "../../../../shared/scss";

:host {
  display: block;
  padding-inline: 10%;

  @include pds-media-query-max("s") {
    padding-inline: p-px-to-rem(27px);
  }

  phn-nd-menu-item {
    margin-block-start: p-px-to-rem(32px);

    @include pds-media-query-min("s") {
      font-size: p-px-to-rem(36px);
    }

    &:first-of-type {
      margin-block-start: 0;
    }
  }
}
